module.exports = __webpack_public_path__ + "media/images/color_admin_v3/user-10-b5a76561a4b1096109cb61925fe6434c.jpg";